var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}arrow-14`,"viewBox":"0 0 14 14"}},[_c('path',{staticClass:"sign arrow",attrs:{"d":"M9,2.4L7.6,3.8L9.8,6H0.3v2h9.5l-2.2,2.2L9,11.6L13.7,7L9,2.4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }